const faqs = [
  { question: 'When?', answer: '08.11.2025 from 23:00 until 09.11.2025 08:00.' },
  {
    question: 'Where?',
    answer: 'Club M01 Berlin, Markgrafendamm 1, 10245 Berlin',
  },
];
export const FaqPage = () => {
  return (
    <div className="flex flex-col gap-4 w-full text-center max-w-[400px]">
      {faqs.map((faq, index) => {
        return (
          <div key={index}>
            <h2 className="font-bold">{faq.question}</h2>
            <p>{faq.answer}</p>
          </div>
        );
      })}
    </div>
  );
};
